import { render, staticRenderFns } from "./GlobalSearchRow.vue?vue&type=template&id=36ff1090&scoped=true"
import script from "./GlobalSearchRow.vue?vue&type=script&lang=ts"
export * from "./GlobalSearchRow.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSearchRow.vue?vue&type=style&index=0&id=36ff1090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff1090",
  null
  
)

export default component.exports